import * as Yup from "yup";

export const validationSchema = Yup.object({
  is_active: Yup.string().required("Status is required!"),
  name: Yup.string().required("Full name is required !"),
});
